module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-32-active.9aacbc83.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-bonuses-32-active.png
// module id = 3184
// module chunks = 11